import React from 'react';
import { motion } from 'framer-motion';
import { FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi';
import '../styles/Pages.css';
import EnhancedHeader from '../components/EnhancedHeader';

const Locations = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };

  return (
    <div className="page-container">
      <EnhancedHeader
        title="Our Locations"
        subtitle="Serving East Ham & Croydon"
        backgroundImage="/images/residential-care-banner.jpg"
        backgroundGradient="linear-gradient(135deg, rgba(46, 204, 113, 0.7) 0%, rgba(22, 160, 133, 0.7) 100%)"
      />

      {/* Locations Grid */}
      <motion.section
        className="locations-section"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <div className="container">
          <div className="locations-grid">
            {/* East Ham */}
            <motion.div
              className="location-card active"
              variants={itemVariants}
              whileHover={{ y: -20, boxShadow: '0 30px 60px rgba(0, 0, 0, 0.15)' }}
            >
              <div className="location-badge">Operational</div>
              <h3>East Ham</h3>
              
              <div className="location-info">
                <div className="info-item">
                  <FiMapPin /> East Ham, London
                </div>
                <div className="info-item">
                  <FiPhone /> Available on request
                </div>
                <div className="info-item">
                  <FiClock /> 24/7 Emergency Support
                </div>
              </div>

              <p>Our flagship location providing comprehensive residential care accommodation with full access to local amenities and community resources.</p>

              <div className="location-image">
                {/* IMAGE PLACEMENT 1: East Ham Location */}
                <img src="/images/hero-slide-1.jpg" alt="East Ham Location" />
              </div>
            </motion.div>

            {/* Croydon */}
            <motion.div
              className="location-card coming-soon"
              variants={itemVariants}
              whileHover={{ y: -20, boxShadow: '0 30px 60px rgba(0, 0, 0, 0.15)' }}
            >
              <div className="location-badge coming">Coming Soon</div>
              <h3>Croydon</h3>
              
              <div className="location-info">
                <div className="info-item">
                  <FiMapPin /> Croydon, London
                </div>
                <div className="info-item">
                  <FiMail /> Contact East Ham office
                </div>
                <div className="info-item">
                  <FiClock /> Expansion planned
                </div>
              </div>

              <p>Expansion to Croydon to extend our services and reach more residents requiring our specialized accommodational services.Watch Out for updates.</p>

              <div className="location-image">
                {/* IMAGE PLACEMENT 2: Croydon Location */}
                <img src="/images/acr12.jpg" alt="Croydon Location" />
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Community Resources Section */}
      <motion.section
        className="community-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <div className="container">
          <h2 className="section-title">Community-Focused Locations</h2>
          <p className="section-text">
            Our residential homes are located in residential areas with access to amenities and community resources, ensuring community integration and accessibility with compliance with UK regulations.
          </p>

          <div className="resources-grid">
            {[
              { title: 'Amenities', items: ['Local shops', 'Parks', 'Transport links', 'Healthcare facilities'] },
              { title: 'Community Resources', items: ['Educational centers', 'Employment agencies', 'Recreation facilities', 'Social services'] },
              { title: 'Accessibility', items: ['Wheelchair accessible', 'Parking available', 'Public transport', 'Easy access routes'] }
            ].map((group, i) => (
              <motion.div
                key={i}
                className="resource-group"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 }
                }}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                whileHover={{ y: -10 }}
              >
                <h3>{group.title}</h3>
                <ul>
                  {group.items.map((item, j) => (
                    <li key={j}>
                      <span className="check">✓</span> {item}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default Locations;
